import {
  AssemblyFilter,
  AssemblyRegistrationStatus,
  assemblyFilterSchema,
} from '@/assembly/api/get-assemblies';
import { AssemblyListing } from '@/assembly/components/assembly-listing';
import { ASSEMBLY_STATUS_OPTIONS } from '@/assembly/constants/status-filter-options';
import { PageContent } from '@/components/page-content';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Route configuration for assembly listing page with registration status parameter.
 */
export const Route = createFileRoute('/_app/assemblies/$registrationStatus')({
  component: AssembliesRoute,
  validateSearch: assemblyFilterSchema.omit({ registrationStatus: true }),
});

/**
 * Main component for the assembly listing page with registration status filter.
 */
function AssembliesRoute() {
  const navigate = Route.useNavigate();
  const { registrationStatus } = Route.useParams();
  const search = Route.useSearch();

  const searchParameters: AssemblyFilter = {
    ...search,
    registrationStatus: registrationStatus as AssemblyRegistrationStatus,
  };

  return (
    <PageContent>
      <AssemblyListing
        searchParameters={searchParameters}
        statusOptions={ASSEMBLY_STATUS_OPTIONS}
        navigateFn={navigate}
      />
    </PageContent>
  );
}
